module.exports = __webpack_public_path__ + "d24153880599e809b8e91bbd9fe2ee78.svg";